import { MIGRATE_AUTO_SCOPE_OPTIONS, MigrateAutoScopeOptions } from '@vy/types';
import { type ChangeEvent, type FC, useState } from 'react';
import { VyDialog } from '../../../../../../../../components/new-design/feedback/VyDialog';
import { VyRadio } from '../../../../../../../../components/new-design/inputs/VyRadio/VyRadio';
import { VyRadioGroup } from '../../../../../../../../components/new-design/inputs/VyRadio/VyRadioGroup';

type MigrateToAutomaticTaxDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (scope: MigrateAutoScopeOptions) => void;
  isLoading: boolean;
};

const SCOPE_OPTIONS: { value: MigrateAutoScopeOptions; label: string }[] = [
  { value: MIGRATE_AUTO_SCOPE_OPTIONS.ALL, label: 'All customers with a manual tax rate' },
  { value: MIGRATE_AUTO_SCOPE_OPTIONS.ZERO_TAX_RATE, label: 'Only customers with a tax rate of 0' },
];

export const MigrateToAutomaticTaxDialog: FC<MigrateToAutomaticTaxDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const [scope, setScope] = useState<MigrateAutoScopeOptions>(MIGRATE_AUTO_SCOPE_OPTIONS.ALL);

  const handleScopeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setScope(event.target.value as MigrateAutoScopeOptions);
  };

  return (
    <VyDialog
      open={open}
      onClose={onClose}
      fullWidth
      label="Migrate to Automatic Tax"
      labelDescription="Choose which customers to migrate from manual tax rates to automatic tax calculation."
      ctaText="Migrate"
      ctaDisabled={isLoading}
      onSubmit={() => onConfirm(scope)}
    >
      <VyRadioGroup
        value={scope}
        onChange={handleScopeChange}
        options={SCOPE_OPTIONS}
        renderOption={(option, _index, isActive) => (
          <VyRadio key={option.value} value={option.value} label={option.label} selected={isActive} />
        )}
      />
    </VyDialog>
  );
};
